/* eslint-disable react-hooks/exhaustive-deps */
import React,{useEffect,useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import api from '../services/api';
import {fmtDateTime} from '../utils/helpers';

const unwrap=(r:any)=>r?.data?.data??r?.data??r;

export default function MortuaryPortalPage(){
  const [params]=useSearchParams();
  const [token,setToken]=useState(params.get('token')||'');
  const [view,setView]=useState<any>(null);
  const [msg,setMsg]=useState('');

  const load=async(t:string)=>{
    if(!t){setMsg('Enter the access token provided by the hospital.');return;}
    try{
      const r=await api.getMortuaryPortal(t);
      setView(unwrap(r));
      setMsg('');
    }catch(e:any){setView(null);setMsg(e.response?.data?.message||'Access denied or expired');}
  };
  useEffect(()=>{if(params.get('token')) load(params.get('token') as string);},[]);

  return(
    <div className="min-h-screen bg-slate-50 p-6">
      <div className="max-w-2xl mx-auto space-y-4">
        <div className="bg-[#02357A] text-white rounded-xl p-4">
          <p className="text-[11px] uppercase tracking-wide opacity-80">Pegasus Clinqov</p>
          <h1 className="text-xl font-bold">Family / funeral director portal</h1>
          <p className="text-xs opacity-80">Operational status only. Autopsy, evidence and police records are never shown here.</p>
        </div>
        {!view&&(
          <div className="bg-white border rounded-xl p-4 space-y-2">
            <input className="w-full border rounded px-3 py-2 text-sm" placeholder="Access token" value={token} onChange={e=>setToken(e.target.value)}/>
            <button className="btn-primary text-sm" onClick={()=>load(token)}>Open</button>
          </div>
        )}
        {msg&&<div className="text-sm bg-white border rounded-lg px-3 py-2">{msg}</div>}
        {view&&(
          <div className="bg-white border rounded-xl p-4 space-y-3 text-sm">
            <p className="text-xs uppercase text-slate-500">{view.kind}</p>
            <h2 className="text-lg font-semibold">{view.bodyNumber} · {view.name}</h2>
            <p>Status: {view.status}{view.releasedAt?` · released ${fmtDateTime(view.releasedAt)}`:''}</p>
            {view.chamber&&<p>Location: {view.chamber}</p>}
            {view.releaseReady!=null&&<p>Release readiness: {view.releaseReady?'Ready for coordination':'Not yet'}</p>}
            {view.payment&&<p>Payment: {view.payment.status} · outstanding {view.payment.outstanding}</p>}
            <div>
              <h3 className="font-semibold">Viewings</h3>
              {(view.viewings||[]).length?view.viewings.map((v:any,i:number)=><p key={i}>{fmtDateTime(v.scheduled_at)} · {v.visitor_name}</p>):<p className="text-slate-500">None scheduled</p>}
            </div>
            <div>
              <h3 className="font-semibold">Chapel / memorial</h3>
              {(view.chapel||[]).length?view.chapel.map((c:any)=><p key={c.booking_number}>{fmtDateTime(c.starts_at)} · {c.service_type} · {c.status}</p>):<p className="text-slate-500">None booked</p>}
            </div>
            <div>
              <h3 className="font-semibold">Transport</h3>
              {(view.trips||[]).length?view.trips.map((t:any)=><p key={t.trip_number}>{fmtDateTime(t.starts_at)} · {t.purpose} · {t.status}</p>):<p className="text-slate-500">None scheduled</p>}
            </div>
            {view.disposition&&<p>Final disposition: {view.disposition.kind} · {view.disposition.destination||''}</p>}
          </div>
        )}
      </div>
    </div>
  );
}
